// Default Layout
//
import React from 'react'
import { Box } from '@mui/material'
import { Outlet, useLocation } from 'react-router-dom'
import NavBar from '../components/NavBar'
import AppSidebar from '../components/AppSidebar'

const NAVBAR_HEIGHT_PX = 64
const SIDEBAR_WIDTH_PX = 240

const isLayoutEditorPath = (pathname = '') =>
  /^\/settings\/controlpanel\/products\/[^/]+\/layout-editor(?:\/[^/]+)?(?:\/|$)/.test(
    pathname
  )

export default function DefaultLayout({
  toggleTheme,
  themeMode,
  isSidebarVisible,
  toggleSidebar,
}) {
  const { pathname } = useLocation()
  const isLayoutEditorRoute = isLayoutEditorPath(pathname)

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: 'background.default',
      }}
    >
      {/* Región superior fija del shell */}
      <NavBar
        isSidebarOpen={isSidebarVisible}
        toggleSidebar={toggleSidebar}
        showSidebarToggle
        toggleTheme={toggleTheme}
        themeMode={themeMode}
      />

      {/* Región lateral reservada por el shell; el render interno lo controla AppSidebar */}
      <Box
        sx={{
          width: isSidebarVisible ? `${SIDEBAR_WIDTH_PX}px` : '0px',
          flex: '0 0 auto',
          minWidth: 0,
          marginTop: `${NAVBAR_HEIGHT_PX}px`,
          height: `calc(100vh - ${NAVBAR_HEIGHT_PX}px)`,
          overflow: 'hidden',
          transition: 'width 0.3s ease',
          borderRight: isSidebarVisible ? '1px solid' : 'none',
          borderColor: 'divider',
        }}
      >
        <AppSidebar isVisible={isSidebarVisible} />
      </Box>

      {/* Región principal de contenido y scroll primario */}
      <Box
        component="main"
        sx={{
          flex: 1,
          minWidth: 0,
          minHeight: 0,
          marginTop: `${NAVBAR_HEIGHT_PX}px`,
          height: `calc(100vh - ${NAVBAR_HEIGHT_PX}px)`,
          overflowX: 'hidden',
          overflowY: isLayoutEditorRoute ? 'hidden' : 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {isLayoutEditorRoute ? (
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
            }}
          >
            <Outlet />
          </Box>
        ) : (
          <Outlet />
        )}
      </Box>
    </Box>
  )
}
